import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { X } from 'lucide-react'

import { cn } from '@/lib/utils'

const BottomSheet = DialogPrimitive.Root

const BottomSheetClose = DialogPrimitive.Close

const BottomSheetTitle = DialogPrimitive.Title

const BottomSheetDescription = DialogPrimitive.Description

const BottomSheetContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay
      className="fixed inset-0 z-50 bg-black/70 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
    />
    <DialogPrimitive.Content
      ref={ref}
      onOpenAutoFocus={event => {
        event.preventDefault()
      }}
      className={cn(
        'app-dialog-surface fixed inset-x-0 bottom-0 z-50 mt-24 grid max-h-[min(85vh,42rem)] w-full gap-0 rounded-t-[1.9rem] border-b-0 border-x-0 p-0 shadow-[0_-20px_48px_rgba(15,23,42,0.22)] duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-bottom-[6%] data-[state=open]:slide-in-from-bottom-[6%] dark:shadow-[0_-20px_48px_rgba(0,0,0,0.34)]',
        className
      )}
      {...props}
    >
      {children}
      <DialogPrimitive.Close className="absolute right-4 top-4 rounded-full border border-border/80 bg-card/88 p-2 text-muted-foreground transition hover:bg-accent hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
        <X className="h-4 w-4" />
        <span className="sr-only">关闭</span>
      </DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
))
BottomSheetContent.displayName = DialogPrimitive.Content.displayName

function BottomSheetHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('border-b border-border/80 px-5 pb-4 pt-3', className)}
      {...props}
    />
  )
}

function BottomSheetHandle({ className }: { className?: string }) {
  return <div className={cn('mx-auto mb-3 h-1.5 w-12 rounded-full bg-border/90', className)} />
}

export {
  BottomSheet,
  BottomSheetClose,
  BottomSheetContent,
  BottomSheetDescription,
  BottomSheetHandle,
  BottomSheetHeader,
  BottomSheetTitle,
}
